<div class="account-header to">
  <div *ngIf="maxVoters === 5" style="display: flex; justify-content: space-between; height: 100%; width: 100%">
    <div class="flex gap-10 align-items-center">
      <div class="version">
        <p class="no-margin text-sm yellow"><span class="text-xs">Version</span><br>{{version}}</p>
      </div>
      <img src="assets/home-page-white-icon.svg" class="profile-icon" (click)="goToPoll()">
      <span class="banner-text hotline-display" id="txt">
        {{'POLL-DASHBOARD.HEADBAND.MESSAGE-CREATION' | translate}}
      </span>
    </div>
    <div class="flex gap-10 align-items-center" style="margin-right: 20px;">
      <img src="assets/user-profile-icon.svg" class="profile-icon" loading="lazy" (click)="goToProfile()">
      <span>
        <p class="banner-text" id="txt2">
          {{accountName}}
        </p>
      </span>
      <button class="text-sm" [ngClass]="['green-button', 'button-change']" (click)="buyOfferPopup()">{{'POLL-DASHBOARD.HEADBAND.BUY' | translate}}</button>
      <img ngSrc="assets/power_settings_new_24px.svg" class="profile-icon pointer" (click)="logout()" loading="lazy"
        height="18" width="20">
    </div>
  </div>
  <div *ngIf="maxVoters === 10"
    style="display: flex; justify-content: space-between; height: 40px; align-items: center;">
    <span>
      <p class="banner-text" id="txt">
        {{'POLL-DASHBOARD.HEADBAND.MESSAGE-CREATION' | translate}}
      </p>
    </span>
    <div style="height: 40px; margin-right: 20px; display: flex; align-items: center;">
      <span>
        <p style="margin: 0;" class="banner-text text-sm" id="txt2">
          {{accountName}}
        </p>
      </span>
      <img src="assets/power_settings_new_24px.svg" class="power-button" (click)="logout()"
        style="cursor: pointer; margin-left: 20px;" loading="lazy">
    </div>
  </div>

  <div *ngIf="maxVoters > 10" class="text-sm"
    style="margin-right: 24px; height: 100%; display: flex; justify-content: space-between; align-items: center;">
    <div class="flex align-items-center gap-10 h-full">
      <div class="version">
        <p class="no-margin text-sm yellow"><span class="text-xs">Version</span><br>{{version}}</p>
      </div>
      <img src="assets/home-page-white-icon.svg" class="profile-icon" (click)="goToPoll()">
    </div>
    <!-- <button *ngIf="!hasHotline else hotline" class="button-change" [ngClass]="['green-button', 'button-change']"
      (click)="triggerPopup()">
      {{'POLL-DASHBOARD.HEADBAND.HOTLINE' | translate}}
    </button> -->
    <ng-template #hotline>
      <p class="banner-text hotline-display">
        {{'POLL-DASHBOARD.HEADBAND.PHONE' | translate}}
      </p>
    </ng-template>

    <span class="right-container">
      <div class="flex align-items-center gap-10">
        <img src="assets/user-profile-icon.svg" (click)="goToProfile()" loading="lazy" class="profile-icon">
        <p class="banner-text text-sm">
          {{accountName}}
        </p>
      </div>
      <button *ngIf="maxVoters > 10 && !licencesReady" class="text-sm"
        [ngClass]="['inactive-large-button']">{{'POLL-DASHBOARD.HEADBAND.LOADING' | translate}}</button>
      <button *ngIf="maxVoters > 10 && licencesReady" [ngClass]="['green-button', 'button-change']" class="text-sm"
        (click)="triggerPopup()">{{'POLL-DASHBOARD.HEADBAND.CHANGE' | translate}}</button>
      <img src="assets/power_settings_new_24px.svg" (click)="logout()" loading="lazy"
        class="profile-icon pointer">
    </span>
  </div>
</div>